<script setup lang="ts">
import { onMounted } from "vue";
import { useThemeStore } from "@/stores/theme";
import { configToaster } from "./utils/toaster";

const themeStore = useThemeStore();

// 启动时应用已持久化的主题偏好
onMounted(() => {
  themeStore.applyTheme();
  configToaster(themeStore.isDarkMode);
});
</script>

<template>
  <!-- 添加特定的命名空间来隔离样式 -->
  <div class="magly-admin-app">
    <router-view></router-view>
  </div>
</template>

<style>
/* 使用命名空间包裹所有样式 */
.magly-admin-app {
  .container {
    max-width: 1200px;
  }

  textarea {
    line-height: 1.6;
    letter-spacing: 0.3px;
  }
}
</style>
